import {
  DatePickerWithLabel,
  Section,
  SectionRow,
  SMALL_INPUT_MIN_WIDTH,
  SMALL_INPUT_WIDTH,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionA = () => {
  const translations = useTranslations();

  return (
    <Section
      title={translations.patientForms.transitionalCareForm.sectionA.title}
    >
      <SectionRow>
        <DatePickerWithLabel
          elementName="transitional_care_start_search_date"
          inputSx={{
            minWidth: SMALL_INPUT_MIN_WIDTH,
            width: SMALL_INPUT_WIDTH,
          }}
          isBold
          label={
            translations.patientForms.transitionalCareForm.sectionA.dateLabel
          }
          shouldDisableFuture
          wrapperSx={{ width: "100%" }}
        />
      </SectionRow>
    </Section>
  );
};
